import { useQuery } from '@tanstack/react-query'
import { request } from 'Lib/axios'

import {
  SearchAddressType,
  SearchResultsResponseType,
} from 'Features/accountSettings/components/Billing/EditBillingDetailsModal/types'
import { ExtractFnReturnType } from 'Lib/react-query'

import useGoogleMapLocationStore from 'Features/accountSettings/components/Billing/EditBillingDetailsModal/store/getGoogleMapLocationStore'

const searchAddress = async (payload: SearchAddressType) => {
  return await request<SearchResultsResponseType>({
    method: 'POST',
    url: `google-maps/search`,
    data: { searchText: payload.searchText, country: payload.country },
  })
}

type QueryFnType = typeof searchAddress

export const useSearchAddress = () => {
  const { searchString, country } = useGoogleMapLocationStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['googleMapsSearchAddress', searchString, country],
    queryFn: () => searchAddress({ searchText: searchString, country }),
    enabled: country.length > 0 && searchString.length > 2,
  })

  const data = !query.data || query.data instanceof Error ? [] : query.data.data

  return { ...query, data }
}
